module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/first.js
// module id = 1671
// module chunks = 0